export default "__VITE_ASSET__5dea9b95__"